(function () {
  "use strict";

  // ── GOOGLE SHEET URL ─────────────────────────────────────────
  var SHEET_URL = "https://script.google.com/macros/s/AKfycbz8KfNF7vl4O25w2XG0HD977dmgQ-ycyX3BSXw27BNuMXb8N-uZFbwN1kA0_mlf-3ZK/exec";
  // ── FLAGS ────────────────────────────────────────────────────
  let popupShown    = false;
  let popupDone     = false;
  let pendingReveal = null;

  // ── SELECTIONS STORE ─────────────────────────────────────────
  let savedSelections = [];

  // ── INIT ─────────────────────────────────────────────────────
  function init() {
    trackAnswerClicks();
    watchForResult();
  }

  // ── ANSWER CLICK TRACKER ─────────────────────────────────────
  function trackAnswerClicks() {
    document.addEventListener("click", function (e) {
      const card = e.target.closest(".answer-card");
      if (!card) return;

      let questionText = "";
      const h2 = document.querySelector(".question-container .question-title, .question-container h2");
      if (h2) questionText = h2.textContent.trim();

      const headingEl  = card.querySelector(".heading");
      const textEl     = card.querySelector(".text");
      const answerText = headingEl ? headingEl.textContent.trim() : "";
      const subText    = textEl    ? textEl.textContent.trim()    : "";

      if (!answerText) return;

      const idx = savedSelections.findIndex(function (s) {
        return s.question === questionText;
      });
      const entry = { question: questionText, answer: answerText, sub: subText };
      if (idx >= 0) {
        savedSelections[idx] = entry;
      } else {
        savedSelections.push(entry);
      }

    }, true);
  }

  // ── MUTATION OBSERVER ────────────────────────────────────────
  function watchForResult() {
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!node.classList) continue;
          if (node.classList.contains("result-container")) {
            if (!popupDone && !popupShown) {
              pendingReveal = node;
              hideResult(node);
              showLeadPopup();
              popupShown = true;
            }
          }
        }
        if (mutation.type === "attributes" && mutation.attributeName === "style") {
          const t = mutation.target;
          if (t.classList && t.classList.contains("result-container")) {
            if (!popupDone && !popupShown) {
              pendingReveal = t;
              hideResult(t);
              showLeadPopup();
              popupShown = true;
            }
          }
        }
      }
    });

    const app = document.getElementById("quizApp") || document.body;
    observer.observe(app, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  // ── HIDE / REVEAL RESULT ─────────────────────────────────────
  function hideResult(node) {
    node.style.visibility = "hidden";
    node.style.opacity    = "0";
  }

  function revealResult(node) {
    if (!node) return;
    node.style.visibility = "";
    node.style.transition = "opacity 0.4s ease";
    node.style.opacity    = "0";
    requestAnimationFrame(function () { node.style.opacity = "1"; });
  }

  // ── LEAD POPUP ───────────────────────────────────────────────
  function showLeadPopup() {
    const existing = document.getElementById("qlp-popup");
    if (existing) existing.remove();

    const popup = document.createElement("div");
    popup.id = "qlp-popup";
    popup.innerHTML = `
      <div class="qlp-overlay"></div>
      <div class="qlp-modal" role="dialog" aria-modal="true" aria-labelledby="qlp-title">

        <div class="qlp-head">
          <div class="qlp-icon">🎁</div>
          <h2 class="qlp-title" id="qlp-title">Your Result is Ready!</h2>
          <p class="qlp-sub">Fill in your details to unlock your personalized result — we'll also send a copy to your email!</p>
        </div>

        <div class="qlp-body">

          <div class="qlp-field">
            <label class="qlp-lbl" for="qlp-name">Full Name *</label>
            <input class="qlp-inp" type="text" id="qlp-name"
              placeholder="Full Name" autocomplete="name" />
            <span class="qlp-err" id="qlp-err-name"></span>
          </div>

          <div class="qlp-field">
            <label class="qlp-lbl" for="qlp-email">Email Address *</label>
            <input class="qlp-inp" type="email" id="qlp-email"
              placeholder="abc@example.com" autocomplete="email" />
            <span class="qlp-err" id="qlp-err-email"></span>
          </div>

          <div class="qlp-field">
            <label class="qlp-lbl" for="qlp-phone">Phone Number *</label>
            <div class="qlp-phone-row">
              <select class="qlp-inp qlp-cc" id="qlp-cc">
                <option value="+91">🇮🇳 +91</option>
                <option value="+92">🇵🇰 +92</option>
                <option value="+971">🇦🇪 +971</option>
                <option value="+1">🇺🇸 +1</option>
                <option value="+44">🇬🇧 +44</option>
                <option value="+61">🇦🇺 +61</option>
              </select>
              <input class="qlp-inp qlp-ph-inp" type="tel"
                id="qlp-phone" placeholder="98765 43210"
                maxlength="10" autocomplete="tel-national" />
            </div>
            <span class="qlp-err" id="qlp-err-phone"></span>
          </div>

          <button class="qlp-btn" id="qlp-submit" onclick="qlpSubmit()">
            <span id="qlp-btn-txt">Unlock My Result ✨</span>
            <span id="qlp-btn-load" style="display:none">⏳ Submitting...</span>
          </button>

          <p class="qlp-privacy">🔒 Your info is safe — we never spam</p>
        </div>

      </div>
    `;

    document.body.appendChild(popup);
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { popup.classList.add("qlp-open"); });
    });
  }

  // ── VALIDATE ─────────────────────────────────────────────────
  function validate() {
    let ok = true;
    const name  = document.getElementById("qlp-name").value.trim();
    const email = document.getElementById("qlp-email").value.trim();
    const phone = document.getElementById("qlp-phone").value.trim();

    document.getElementById("qlp-err-name").textContent  = "";
    document.getElementById("qlp-err-email").textContent = "";
    document.getElementById("qlp-err-phone").textContent = "";

    if (name.length < 2) {
      document.getElementById("qlp-err-name").textContent = "Please enter your full name.";
      ok = false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      document.getElementById("qlp-err-email").textContent = "Please enter a valid email.";
      ok = false;
    }
    if (!/^\d{10}$/.test(phone.replace(/\s/g, ""))) {
      document.getElementById("qlp-err-phone").textContent = "Please enter a 10-digit phone number.";
      ok = false;
    }
    return ok;
  }

  // ── SUBMIT ───────────────────────────────────────────────────
window.qlpSubmit = async function () {
    if (!validate()) return;

    const name  = document.getElementById("qlp-name").value.trim();
    const email = document.getElementById("qlp-email").value.trim();
    const cc    = document.getElementById("qlp-cc").value;
    const phone = document.getElementById("qlp-phone").value.trim();
    const full  = cc + phone;

    document.getElementById("qlp-btn-txt").style.display  = "none";
    document.getElementById("qlp-btn-load").style.display = "inline";
    document.getElementById("qlp-submit").disabled = true;

    // ── Quiz answers string banao (backup ke liye) ────────────
    var selectionsText = "";
    if (savedSelections.length > 0) {
      selectionsText = savedSelections.map(function (s) {
        var line = "Q: " + (s.question || "—") + " | A: " + s.answer;
        if (s.sub) line += " (" + s.sub + ")";
        return line;
      }).join(" || ");
    }

    // ── Answers ko alag columns ke liye map karo ──────────────
    var answersObj = {};
    savedSelections.forEach(function (s) {
      var q = (s.question || "").toLowerCase();
      if      (q.includes("which sport"))                          answersObj["sport"]         = s.answer;
      else if (q.includes("played") && q.includes("before"))      answersObj["played_before"] = s.answer;
      else if (q.includes("how long"))                             answersObj["experience"]    = s.answer;
      else if (q.includes("level of play"))                        answersObj["level"]         = s.answer;
      else if (q.includes("achieve"))                              answersObj["goal"]          = s.answer;
      else if (q.includes("game style"))                           answersObj["game_style"]    = s.answer;
      // Padel specific
      else if (q.includes("other racket"))                         answersObj["racket_bg"]     = s.answer;
      else if (q.includes("padel") && q.includes("know"))         answersObj["padel_level"]   = s.answer;
      // Table Tennis specific
      else if (q.includes("table tennis") || q.includes("tt"))    answersObj["tt_level"]      = s.answer;
    });

    // ── Recommended product nikalo ────────────────────────────
    var productText = "";
    var productEls = document.querySelectorAll(".result-container .product_info h4, .result-container .h6");
    var products = [];
    productEls.forEach(function (el) {
      var t = el.textContent.trim();
      if (t) products.push(t);
    });
    productText = products.join(", ");

    // ── Google Sheet mein bhejo ───────────────────────────────
    try {
      await fetch(SHEET_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name:       name,
          email:      email,
          phone:      full,
          answers:    answersObj,   // ← naya: alag columns
          selections: selectionsText, // ← purana: backup string
          product:    productText
        })
      });
    } catch (err) {
      console.warn("Sheet submit error:", err);
    }

    // ── Shopify Contact Form mein bhi bhejo (backup) ──────────
    // try {
    //   const message = buildMessage(name, email, full);
    //   const fd = new FormData();
    //   fd.append("form_type",      "contact");
    //   fd.append("utf8",           "✓");
    //   fd.append("contact[name]",  name);
    //   fd.append("contact[email]", email);
    //   fd.append("contact[phone]", full);
    //   fd.append("contact[body]",  message);

    //   await fetch("/contact#contact_form", {
    //     method:  "POST",
    //     headers: { "Accept": "application/json" },
    //     body:    fd,
    //   });
    // } catch (e) {
    //   console.warn("Contact form error:", e);
    // }

    popupDone = true;
    closePopup();
    if (pendingReveal) revealResult(pendingReveal);
  };

  // ── MESSAGE BUILD (Shopify backup ke liye) ────────────────────
  function buildMessage(name, email, phone) {
    const now = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });

    var selectionLines = "";
    if (savedSelections.length > 0) {
      selectionLines = savedSelections.map(function (s) {
        var line = "Q: " + (s.question || "—") + "\nA: " + s.answer;
        if (s.sub) line += " — " + s.sub;
        return line;
      }).join("\n\n");
    } else {
      selectionLines = "(No selections captured)";
    }

    var resultTitle = "";
    var resultEl = document.querySelector(".result-container h1, .result-container .question-title");
    if (resultEl) resultTitle = resultEl.textContent.trim();

    var products = [];
    document.querySelectorAll(".result-container .product_info h4, .result-container .h6").forEach(function (el) {
      products.push("• " + el.textContent.trim());
    });

    return [
      "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
      "🎾 QUIZ LEAD — " + now,
      "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
      "",
      "👤 NAME  : " + name,
      "📧 EMAIL : " + email,
      "📱 PHONE : " + phone,
      "",
      "━━━━ QUIZ SELECTIONS ━━━━━━━━",
      selectionLines,
      "",
      "━━━━ RECOMMENDED RESULT ━━━━━",
      resultTitle ? "🎯 " + resultTitle : "(Result title not found)",
      products.length > 0 ? "\nProducts:\n" + products.join("\n") : "",
      "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━",
    ].join("\n");
  }

  // ── CLOSE POPUP ──────────────────────────────────────────────
  function closePopup() {
    const popup = document.getElementById("qlp-popup");
    if (!popup) return;
    popup.classList.remove("qlp-open");
    setTimeout(function () { popup.remove(); }, 380);
    document.body.style.overflow = "";
  }

  // ── START ─────────────────────────────────────────────────────
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();